import { Facility } from '@reliance/types/models/Facility';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useUser } from '../contexts/UserContext';
import Edit from './Edit';
import EditBilling from './EditBilling';
import EditCalling from './EditCalling';
import EditTaxes from './EditTaxes';
import EditTrustAccounts from './EditTrustAccounts';
import MigrateItdsModal from './MigrateItdsModal';

type EditModalProps = {
  facility: Facility;
  onSave(saved?: boolean): any;
};

const EditModal: React.FC<EditModalProps> = (props) => {
  const { facility, onSave } = props;

  const user = useUser();
  const [showMigrateItdsModal, setShowMigrateItdsModal] = useState(false);

  return (
    <Modal dialogClassName="modal-full" show={true}>
      <Modal.Body>
        <Tabs defaultActiveKey="general">
          <Tab title="General" eventKey="general">
            <Edit facility={facility} onSave={() => onSave(true)} />
          </Tab>

          {user.hasPermission('facility_manage_billing') &&
            <Tab title="Billing" eventKey="billing" mountOnEnter={true}>
              <EditBilling facility={facility} onSave={() => onSave(true)} />
            </Tab>
          }

          {user.hasPermission('facility_manage_taxes') &&
            <Tab title="Taxes" eventKey="taxes" mountOnEnter={true}>
              <EditTaxes facility={facility} onSave={() => onSave(true)} />
            </Tab>
          }

          <Tab title="Calling" eventKey="calling" mountOnEnter={true}>
            <EditCalling facility={facility} onSave={() => onSave(true)} />
          </Tab>

          {user.hasPermission('facility_manage_trust_accounts') &&
            <Tab title="Trust Accounts" eventKey="trustAccounts" mountOnEnter={true}>
              <EditTrustAccounts
                facility={facility}
                onSave={() => onSave(true)}
                onMigrateToFull={() => setShowMigrateItdsModal(true)}
              />
              <MigrateItdsModal
                show={showMigrateItdsModal}
                facility={facility}
                onClose={(migrated) => {
                  if (migrated) {
                    onSave(true);
                  }
                  setShowMigrateItdsModal(false);
                }} />
            </Tab>
          }
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.onSave(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;
